import { ArrowDownRight } from "lucide-react";
import { profile, photographs } from "../data/mock";

const Hero = () => {
  const heroPhoto = photographs.find((p) => p.id === "p1");
  const accent = photographs.find((p) => p.id === "p2");

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="home" className="relative pt-32 md:pt-40 pb-20 md:pb-28">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 md:gap-10 items-end">
          {/* Left: tagline */}
          <div className="col-span-12 md:col-span-7 order-2 md:order-1">
            <div className="text-xs tracking-[0.25em] uppercase text-[#8B6F47] mb-6 reveal">
              Portfolio · 2023–2026 · {profile.region}
            </div>
            <h1 className="font-display text-[56px] md:text-[112px] leading-[0.95] tracking-tight reveal">
              Frames that
              <br />
              <span className="italic-display text-[#8B6F47]">remember</span> for you.
            </h1>
            <p className="mt-8 max-w-xl text-[15px] md:text-base leading-relaxed text-[#1A1A1A]/75 reveal">
              {profile.shortBio}
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4 reveal">
              <button
                onClick={() => scrollTo("photography")}
                className="btn-primary rounded-full px-6 py-3.5 text-sm tracking-wide inline-flex items-center gap-2"
              >
                View Work <ArrowDownRight size={16} />
              </button>
              <button
                onClick={() => scrollTo("contact")}
                className="btn-ghost rounded-full px-6 py-3.5 text-sm tracking-wide"
              >
                Start a Project
              </button>
            </div>
          </div>

          {/* Right: featured images collage */}
          <div className="col-span-12 md:col-span-5 order-1 md:order-2 relative">
            <div className="relative aspect-[4/5] w-full hover-zoom reveal">
              <img
                src={heroPhoto.src}
                alt={heroPhoto.alt}
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute left-4 bottom-4 bg-[#F5F1EA]/90 backdrop-blur-sm px-3 py-2 text-[11px] tracking-widest uppercase">
                {heroPhoto.title} · {heroPhoto.location}
              </div>
            </div>
            <div className="hidden lg:block absolute right-8 -bottom-14 w-[170px] aspect-square hover-zoom border-[6px] border-[#F5F1EA] shadow-2xl z-10">
              <img src={accent.src} alt={accent.alt} className="w-full h-full object-cover" />
            </div>
          </div>
        </div>

        {/* Scrolling tagline marquee */}
        <div className="mt-24 overflow-hidden border-y border-[#1A1A1A]/10 py-6">
          <div className="marquee-track flex gap-16 whitespace-nowrap">
            {[...Array(2)].map((_, k) => (
              <div key={k} className="flex gap-16 items-center shrink-0">
                {[
                  "Engagements",
                  "Live Music",
                  "Lifestyle & Family",
                  "Senior Portraits",
                  "Business & Brand",
                  "Documentary Film",
                  "Event Recap",
                ].map((w, i) => (
                  <span
                    key={`${k}-${i}`}
                    className="font-display italic-display text-3xl md:text-5xl text-[#1A1A1A]/30"
                  >
                    {w} —
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
